(function(){
if(window.__lllCustomInit) return; window.__lllCustomInit=1;
/* A/B rollout arm marker: fires on every treatment-theme page — this file loads sitewide via
   sections/lll-footer.liquid (plus per-section tags on the custom PDP + offer sections; the
   run-once guard below makes duplicate tags harmless). Control never loads this file. */
try{
  window.dataLayer=window.dataLayer||[];
  window.dataLayer.push({event:'lll_theme_variant', lll_variant:'tom_revamp'});
  if(typeof window.gtag==='function'){ window.gtag('event','lll_theme_variant',{lll_variant:'tom_revamp'}); }
}catch(e){}

/* --- drawer-aware add to cart (Bracken 2026-07-28) -----------------------
   The custom PDP was the only buy box on this theme that LEFT the page on
   add: a plain ATC fell through to a native <form> POST (the old handler
   returned without preventDefault) and the add-on / pairs paths finished
   with location.href='/cart'. Every add below now goes through /cart/add.js
   and renders Dawn's cart drawer in place, matching the blanket PDPs.
   Falls back to /cart if there is no drawer or the request fails. */
function lllDrawerAdd(items, btn, onFail){
  var drawer=document.querySelector('cart-drawer');
  var label=btn?(btn.dataset.label||btn.textContent):null;
  if(btn){ btn.disabled=true; btn.textContent='Adding\u2026'; }
  var restore=function(){ if(btn){ btn.disabled=false; btn.textContent=label; } };
  var body={items:items};
  if(drawer&&typeof drawer.getSectionsToRender==='function'){
    body.sections=drawer.getSectionsToRender().map(function(s){ return s.id; });
    body.sections_url=window.location.pathname;
  }
  return fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/javascript'},
    body:JSON.stringify(body)
  })
  .then(function(r){ if(!r.ok) throw new Error('cart/add '+r.status); return r.json(); })
  .then(function(res){
    restore();
    if(drawer&&typeof drawer.renderContents==='function'&&res&&res.sections){
      if(typeof drawer.setActiveElement==='function'&&btn) drawer.setActiveElement(btn);
      drawer.renderContents(res);
      /* Dawn's own product-form does this in its finally(). Without it the drawer
         keeps the is-empty class it was RENDERED with (cart was empty at page load)
         and the theme CSS hides every line item: the drawer looks blank even though
         the markup is all there. (Thomas spotted it 2026-07-28.) */
      drawer.classList.remove('is-empty');
    } else { window.location.href='/cart'; }
  })
  .catch(function(){ restore(); if(onFail) onFail(); else window.location.href='/cart'; });
}

/* LLL custom PDP v2 (concept port) */
function lllInit(){
  /* scroll reveals — independent of the buy box, never skipped */
  try{
    var io=new IntersectionObserver(function(es){es.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target);} });},{threshold:.12});
    document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  }catch(e){ document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); }); }

  /* buy-box block runs only on the custom PDP; everything after it (pairs, offer cards,
     code applier) is page-agnostic and must NOT be skipped on other templates */
  var root=document.querySelector('[data-cx]');
  if(root) try{
  var data=JSON.parse(document.getElementById('cx-product').textContent);
  var money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency,currencyDisplay:'narrowSymbol'});
  var state={};
  root.querySelectorAll('input[data-opt]').forEach(function(i){ if(i.checked) state[i.dataset.opt]=i.value; });

  /* gallery: every cover/label/media is a permanent slide; the current print+label activates its cover */
  var printIdx=null, labelIdx=null;
  (function(){ var s=root.querySelector('.cx-swatches input[data-opt]'); if(s) printIdx=s.dataset.opt;
               var p=root.querySelector('.cx-pills input[data-opt]'); if(p) labelIdx=p.dataset.opt; })();
  var stickyImg=document.querySelector('[data-cx-sticky-img]');
  function coverWS(v){ return /silk/i.test(v||'') ? 'silk' : 'woven'; }
  function coverKey(){
    var k=(state[printIdx]||'')+'|'+coverWS(state[labelIdx]);
    if(dIdx!==null && state[dIdx] && state[dIdx]!==dFirst && root.querySelector('.cx-slide[data-i="'+k+'|'+state[dIdx]+'"]')) return k+'|'+state[dIdx];
    return k;
  }

  /* Design option (Animals launch, 1 Nov 2026, agreed with Rory): the design row shows for every print. A design
     that isn't on sale with the chosen print and label is greyed out and can't be picked (sold-out script in
     lll-custom-pdp); moving to such a print or label goes back to the first design. The price above updates to the
     design picked (Thomas, 1 Nov: no "+$5" on the pill). */
  var designRow=root.querySelector('[data-cx-design-row]');
  var dIn=designRow?designRow.querySelector('input[data-opt]'):null;
  var dIdx=dIn?dIn.dataset.opt:null, dFirst=dIn?dIn.value:null;
  function variantWith(idx,val){
    return data.variants.find(function(v){
      return v.options.every(function(x,i){ return String(i)===String(idx)?x===val:state[String(i)]===x; });
    });
  }
  function syncDesign(){
    if(!designRow) return;
    var cur=variantWith(dIdx,state[dIdx]);
    if(state[dIdx]!==dFirst && !(cur&&cur.available)){
      state[dIdx]=dFirst;
      designRow.querySelectorAll('input[data-opt]').forEach(function(i){ i.checked=(i.value===dFirst); });
    }
  }

  function findVariant(){
    return data.variants.find(function(v){
      return v.options.every(function(val,idx){ return state[String(idx)]===val; });
    });
  }
  function render(){
    var v=findVariant();
    var atc=root.querySelector('.cx-atc'), idInput=root.querySelector('input[name="id"]');
    root.querySelectorAll('[data-selname]').forEach(function(el){
      var i=el.dataset.selname; var raw=state[i]||''; el.textContent=(data.display[raw]||raw);
    });
    if(!v){ if(atc){atc.disabled=true; atc.textContent='Unavailable';} return; }
    if(idInput) idInput.value=v.id;
    var p=root.querySelector('[data-cx-price]'); if(p) p.textContent=money.format(v.price/100);
    var cmp=root.querySelector('[data-cx-compare]');
    if(cmp){ if(v.compare_at_price>v.price){cmp.style.display='';cmp.textContent=money.format(v.compare_at_price/100);} else {cmp.style.display='none';} }
    /* the Sale tag follows the was-price: Animals has none in AU (1 Nov 2026) */
    var sale=root.querySelector('[data-cx-sale]'); if(sale) sale.style.display=(v.compare_at_price>v.price)?'':'none';
    if(atc){ if(v.available){ atc.disabled=false; atc.textContent=atc.dataset.label; } else { atc.disabled=true; atc.textContent='Sold out'; } }
    var sp=document.querySelector('[data-cx-sticky-price]'); if(sp) sp.textContent=money.format(v.price/100);
  }

  /* gallery */
  var slides=root.querySelectorAll('.cx-slide'), thumbs=root.querySelectorAll('.cx-thumb');
  function activate(i){
    slides.forEach(function(s){
      var on = s.dataset.i===String(i);
      s.classList.toggle('is-on',on);
      var vid=s.querySelector('video'); if(vid){ on?vid.play().catch(function(){}):vid.pause(); }
      if(on){ var im=s.querySelector('img'); if(im && stickyImg) stickyImg.src=im.getAttribute('src'); }
    });
    thumbs.forEach(function(t){ t.classList.toggle('is-on', t.dataset.i===String(i)); });
  }
  thumbs.forEach(function(t){ t.addEventListener('click',function(){ activate(t.dataset.i); }); });

  /* two-up print sync */
  function syncTwoUp(handle){
    var el=document.querySelector('[data-lll-twoup]'); if(!el) return;
    var p=el.dataset[handle+'Printed']||el.dataset[handle.replace(/-([a-z])/g,function(m,c){return c.toUpperCase();})+'Printed'];
    var m=el.dataset[handle+'Minky']||el.dataset[handle.replace(/-([a-z])/g,function(m2,c){return c.toUpperCase();})+'Minky'];
    var L=el.querySelector('[data-tex-l]'), R=el.querySelector('[data-tex-r]');
    if(p&&L) L.src=p; if(m&&R) R.src=m;
  }

  root.addEventListener('change',function(e){
    if(!e.target.matches('input[data-opt]')) return;
    state[e.target.dataset.opt]=e.target.value; syncDesign(); render();
    /* jump the gallery to the cover matching the current print + label */
    activate(coverKey());
    /* two-up print sync only when a PRINT swatch changed */
    var sw=e.target.closest('.cx-swatch');
    if(sw){ syncTwoUp(e.target.value.toLowerCase().replace(/[^a-z0-9]+/g,'-')); }
  });

  /* sticky bar */
  var sticky=document.querySelector('.cx-sticky'), anchor=root.querySelector('.cx-atc');
  if(sticky&&anchor&&'IntersectionObserver' in window){
    /* Show only once the buy button has scrolled off the TOP of the viewport.
       The old test was just !isIntersecting, which is also true while the button
       is still BELOW the fold — so on mobile (button ~890px, viewport ~812px) the
       bar appeared the instant the page loaded, covering the price before the
       customer had scrolled at all. Seen in Clarity recordings (Thomas 2026-07-29). */
    new IntersectionObserver(function(en){
      var e=en[0];
      sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
    },{threshold:0}).observe(anchor);
    var sb=sticky.querySelector('[data-cx-sticky-btn]');
    if(sb) sb.addEventListener('click',function(){ var f=document.getElementById('cx-form'); if(f) f.requestSubmit(); });
  }
  syncDesign();
  render();
  activate(coverKey());


  /* Second-pack add-on v2: visible print+label pickers, follow-main until touched,
     thumbnail reflects the chosen print, interacting auto-ticks the box. */
  var addonPick=null;   /* set by the add-on block below when a 2nd pack is selected */
  var addon=root.querySelector('[data-cx-addon]');
  if(addon){
    var tgl=addon.querySelector('[data-addon-toggle]');
    var aImg=addon.querySelector('[data-addon-img]');
    var colourIdx=(root.querySelector('.cx-swatches input[data-opt]')||{}).dataset ? root.querySelector('.cx-swatches input[data-opt]').dataset.opt : '0';
    var pillIdx=(root.querySelector('.cx-pills input[data-opt]')||{}).dataset ? root.querySelector('.cx-pills input[data-opt]').dataset.opt : '1';
    var touchedPrint=false, touchedLabel=false, touchedDesign=false;

    function handleize(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); }
    function swatchUrlFor(printVal){
      var main=root.querySelector('.cx-swatches input[value="'+printVal+'"]');
      if(!main) return null;
      var dot=main.parentElement.querySelector('.dot');
      if(!dot) return null;
      var bg=dot.style.backgroundImage;
      return bg?bg.slice(5,-2):null;
    }
    function pickedPrint(){ var p=addon.querySelector('input[name="cx-addon-print"]:checked'); return p?p.value:null; }
    function pickedLabel(){ var l=addon.querySelector('input[name="cx-addon-label"]:checked'); return l?l.value:null; }
    function pickedDesign(){ var d=addon.querySelector('input[name="cx-addon-design"]:checked'); return d?d.value:null; }
    /* Design option. The second pack has its own Signature / Animals choice (Thomas, 1 Nov 2026), starting from the
       main pick like print and label do. A design not on sale with the second pack's print + label is greyed out
       and can't be picked; it then falls back to the first design (Animals is Woodland only at launch). */
    var designIn=root.querySelector('[data-cx-design] input[data-opt], input.cx-design-fixed');
    var designIdx=designIn?designIn.dataset.opt:null, designFirst=designIn?designIn.value:null;
    function addonExact(printVal,labelVal,d){
      return data.variants.find(function(v){
        return v.options[parseInt(colourIdx,10)]===printVal && v.options[parseInt(pillIdx,10)]===labelVal && v.available
          && (designIdx===null || d===null || v.options[parseInt(designIdx,10)]===d);
      });
    }
    function addonVariant(printVal,labelVal){
      if(designIdx===null) return addonExact(printVal,labelVal,null);
      return addonExact(printVal,labelVal,pickedDesign()||state[designIdx]) || addonExact(printVal,labelVal,designFirst);
    }
    function refreshAddon(){
      var lbl = touchedLabel && pickedLabel() ? pickedLabel() : state[pillIdx];
      addon.querySelectorAll('input[name="cx-addon-label"]').forEach(function(i){ i.checked=(i.value===lbl); });
      addon.querySelectorAll('input[name="cx-addon-print"]').forEach(function(d){
        var ok=!!addonVariant(d.value,lbl);
        d.disabled=!ok;
        d.closest('.cx-addon__dot').style.opacity=ok?'1':'.3';
      });
      var cur=addon.querySelector('input[name="cx-addon-print"]:checked');
      var follow=!touchedPrint || !cur || cur.disabled;
      if(follow){
        var pref=addon.querySelector('input[name="cx-addon-print"][value="'+(state[colourIdx]||'')+'"]');
        if(pref&&!pref.disabled){ pref.checked=true; }
        else{ var first=[...addon.querySelectorAll('input[name="cx-addon-print"]')].find(function(d){return !d.disabled;}); if(first) first.checked=true; }
      }
      var dIns=[].slice.call(addon.querySelectorAll('input[name="cx-addon-design"]'));
      if(dIns.length){
        var dp=pickedPrint(), want=(touchedDesign&&pickedDesign())?pickedDesign():state[designIdx];
        dIns.forEach(function(i){ i.disabled=!addonExact(dp,lbl,i.value); });
        var dOk=dIns.find(function(i){ return i.value===want && !i.disabled; }) || dIns.find(function(i){ return i.value===designFirst; });
        dIns.forEach(function(i){ i.checked=(i===dOk); });
      }
      var p=pickedPrint(); var u=p?swatchUrlFor(p):null;
      if(u&&aImg) aImg.src=u;
    }
    addon.addEventListener('change',function(e){
      if(e.target.matches('input[name="cx-addon-print"]')){ if(e.isTrusted) touchedPrint=true; if(e.isTrusted&&!tgl.checked){ tgl.checked=true; } refreshAddon(); }
      if(e.target.matches('input[name="cx-addon-label"]')){ if(e.isTrusted) touchedLabel=true; if(e.isTrusted&&!tgl.checked){ tgl.checked=true; } refreshAddon(); }
      if(e.target.matches('input[name="cx-addon-design"]')){ if(e.isTrusted) touchedDesign=true; if(e.isTrusted&&!tgl.checked){ tgl.checked=true; } refreshAddon(); }
    });
    function syncAtcLabel(){
      var btn=document.querySelector('.cx-atc'); if(!btn||btn.disabled) return;
      var main=findVariant();
      var pct=parseInt(addon.dataset.dealPct||'0',10);
      /* keep the card's price row on the SELECTED variant (Liquid renders the default one) */
      var row=addon.querySelector('.cx-addon__price');
      var p=pickedPrint(); var lbl=pickedLabel()||state[pillIdx];
      /* the second pack can cost more or less than the first since Animals (1 Nov 2026), so price the one picked */
      var pv=p?addonVariant(p,lbl):null, second=pv?pv.price:(main?main.price:0);
      if(row&&main&&pct>0){
        var full=main.price+second, deal=Math.round(full*(100-pct)/100);
        row.innerHTML='<span class="cx-addon__amt">'+money.format(deal/100)+'</span> <s>'+money.format(full/100)+'</s>';
      }
      /* group B: checkout takes 60% off the CHEAPER pack of the pair (volume-30), which only differs once prices do */
      var cheap=main?Math.min(main.price,second):second;
      var rowB=addon.querySelector('.cx-addon__price-b');
      if(rowB&&main) rowB.innerHTML='<span class="cx-addon__amt">'+money.format(Math.round(cheap*40/100)/100)+'</span> <s>'+money.format(cheap/100)+'</s>';
      var v=(tgl.checked&&p)?pv:null;
      if(v&&main){
        var tot=main.price+v.price;
        if(window.LLL_OFFER==='b') tot-=Math.round(Math.min(main.price,v.price)*60/100);
        else if(pct>0) tot=Math.round(tot*(100-pct)/100);
        btn.textContent='Add both to cart · '+money.format(tot/100);
      }
      else { btn.textContent=btn.dataset.label; }
    }
    tgl.addEventListener('change',function(){ syncAtcLabel(); });
    /* Second pack is INDEPENDENT of the main pickers (Thomas 2026-07-14): it inherits the
       main selection ONCE at load as its starting default, then never follows again. Main
       changes still refresh the pricing line via syncAtcLabel. */
    root.addEventListener('change',function(e){ if(e.target.matches('input[data-opt]')) syncAtcLabel(); });
    addon.addEventListener('change',function(){ syncAtcLabel(); });
    refreshAddon();
    touchedPrint=true; touchedLabel=true; touchedDesign=true;
    syncAtcLabel();
    window.addEventListener('pageshow',function(e){
      if(!e.persisted) return;
      var b=document.querySelector('.cx-atc');
      if(b){ b.disabled=false; b.textContent=b.dataset.label; }
      if(tgl.checked){ tgl.checked=false; }
      refreshAddon(); syncAtcLabel();
    });

    /* the add-on only decides whether a SECOND pack rides along. The submit
       handler itself now lives outside this block, so a plain Add to Cart is
       still intercepted when the add-on is absent from the page. */
    addonPick=function(){
      if(!tgl.checked) return null;
      var p=pickedPrint(); var lbl=pickedLabel()||state[pillIdx];
      return p?addonVariant(p,lbl):null;
    };
  }

  var formEl=document.getElementById('cx-form');
  if(formEl) formEl.addEventListener('submit',function(ev){
    ev.preventDefault();
    var btn=formEl.querySelector('.cx-atc');
    if(btn&&btn.disabled) return;
    var idEl=formEl.querySelector('input[name="id"]');
    if(!idEl||!idEl.value) return;
    var items=[{id:parseInt(idEl.value,10),quantity:1}];
    var extra=addonPick?addonPick():null;
    if(extra) items.push({id:extra.id,quantity:1});
    lllDrawerAdd(items,btn,function(){ formEl.submit(); });
  });

  }catch(e){ console.error('[lll-custom] buy box init failed:', e); }

  /* pairs section: pick each product's variant via dropdowns, add both together (v27) */
  try{
    var pBtn=document.querySelector('[data-pairs-atc]');
    var selCur=document.querySelector('[data-pairs-cur]');
    var selCross=document.querySelector('[data-pairs-cross]');
    if(pBtn&&selCross){
      var optAvail=function(sel){
        if(!sel) return true;
        if(sel.tagName!=='SELECT') return true;
        var o=sel.options[sel.selectedIndex];
        return !!o && !o.disabled;
      };
      var pairsOK=function(){ return optAvail(selCross) && optAvail(selCur); };
      var pairsSync=function(){
        if(pairsOK()){ pBtn.disabled=false; pBtn.textContent=pBtn.getAttribute('data-label'); }
        else { pBtn.disabled=true; pBtn.textContent='Sold out'; }
      };
      selCross.addEventListener('change',pairsSync);
      if(selCur) selCur.addEventListener('change',pairsSync);
      pairsSync();
      var bindImg=function(sel){
        if(!sel||sel.tagName!=='SELECT') return;
        var cell=sel.closest('.lll-pairs__cell'), img=cell&&cell.querySelector('.lll-pairs__ph img');
        if(!img) return;
        sel.addEventListener('change',function(){ var o=sel.options[sel.selectedIndex], u=o&&o.getAttribute('data-img'); if(u) img.src=u; });
      };
      bindImg(selCur); bindImg(selCross);
      pBtn.addEventListener('click',function(){
        if(!pairsOK()||pBtn.textContent==='Adding\u2026') return;
        var items=[];
        if(selCur&&selCur.value){ items.push({id:parseInt(selCur.value,10),quantity:1}); }
        else { var mainInput=document.querySelector('#cx-form input[name="id"]'); if(mainInput) items.push({id:parseInt(mainInput.value,10),quantity:1}); }
        items.push({id:parseInt(selCross.value,10),quantity:1});
        lllDrawerAdd(items,pBtn,pairsSync);
      });
      window.addEventListener('pageshow',function(e){ if(e.persisted) pairsSync(); });
    }
  }catch(e){ console.error('[lll-custom] pairs init failed:', e); }

  /* ===== v23 code applier — DORMANT. Plan locked 2026-07-07: one engine, native AUTOMATIC
     discounts on both arms (no codes). Codes stay empty -> this is a permanent no-op unless a
     code-based test is ever revived. ===== */
  var LLL_CODES = { minis30: '', bundle15: '', blanket2: '' };
  var LLL_IDS = {"minis": [15568402612305, 15720622096465], "blankets": [7845705416785, 15720615215185], "muslin": 7845705416785};
  var LLL_PCT = { minis30: 0.30, bundle15: 0.15, blanket2: 0.15 };
  function lllApplyBestCode(){
    if(!LLL_CODES.minis30 && !LLL_CODES.bundle15 && !LLL_CODES.blanket2) return Promise.resolve();
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var minisQty=0, minisVal=0, blanketQty=0, blanketVal=0, muslinQty=0, muslinVal=0;
      c.items.forEach(function(i){
        if(LLL_IDS.minis.indexOf(i.product_id)>-1){ minisQty+=i.quantity; minisVal+=i.original_line_price; }
        if(LLL_IDS.blankets.indexOf(i.product_id)>-1){ blanketQty+=i.quantity; blanketVal+=i.original_line_price; }
        if(i.product_id===LLL_IDS.muslin){ muslinQty+=i.quantity; muslinVal+=i.original_line_price; }
      });
      var cand=[];
      if(LLL_CODES.minis30 && minisQty>=2) cand.push({code:LLL_CODES.minis30, save:minisVal*LLL_CU.pct.minis30});
      if(LLL_CODES.blanket2 && muslinQty>=2) cand.push({code:LLL_CODES.blanket2, save:muslinVal*LLL_PCT.blanket2});
      if(LLL_CODES.bundle15 && minisQty>=1 && blanketQty>=1) cand.push({code:LLL_CODES.bundle15, save:(minisVal+blanketVal)*LLL_CU.pct.bundle15});
      if(!cand.length) return;
      cand.sort(function(a,b){ return b.save-a.save; });
      return fetch('/discount/'+encodeURIComponent(cand[0].code)).catch(function(){});
    }).catch(function(){});
  }
  try{ lllApplyBestCode(); }catch(e){}

  /* ===== v23: volume offer card ===== */
  try{
    document.querySelectorAll('[data-lll-vol]').forEach(function(card){
      var btn=card.querySelector('[data-vol-atc]');
      var sync=function(){
        var two=card.querySelector('input[value="2"]:checked');
        card.querySelectorAll('.lll-vol__opt').forEach(function(o){ o.classList.toggle('on', o.querySelector('input').checked); });
        btn.disabled=false; btn.innerHTML = two ? btn.getAttribute('data-l2') : btn.getAttribute('data-l1');
      };
      card.addEventListener('change', sync); sync();
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        var two=card.querySelector('input[value="2"]:checked');
        var qty= two ? parseInt(card.getAttribute('data-qty2'),10) : 1;
        var main=document.querySelector('form[action*="/cart/add"] input[name="id"]');
        var vid=parseInt((main&&main.value)||card.getAttribute('data-variant'),10);
        btn.disabled=true; btn.textContent='Adding…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:qty}]})})
          .then(function(){ return lllApplyBestCode(); })
          .then(function(){ window.location.href='/cart'; })
          .catch(function(){ sync(); });
      });
      window.addEventListener('pageshow',function(e){ if(e.persisted) sync(); });
    });
  }catch(e){ console.error('[lll-custom] volume card init failed:', e); }

  /* ===== v23: free-mini claim card ===== */
  try{
    var gCard=document.querySelector('[data-lll-gift]');
    if(gCard && gCard.querySelector('[data-gift-atc]')){
      var gBtn=gCard.querySelector('[data-gift-atc]');
      var gData=JSON.parse(gCard.querySelector('[data-gift-data]').textContent);
      var gOpts=gCard.querySelector('[data-gift-opts]');
      var giftVariant=function(){
        var groups=gOpts?gOpts.querySelectorAll('.lll-gift__optrow'):[];
        for(var i=0;i<gData.variants.length;i++){
          var v=gData.variants[i], ok=true;
          for(var g=0; g<groups.length; g++){
            var idx=parseInt(groups[g].getAttribute('data-opt-index'),10);
            var sel=groups[g].querySelector('input:checked');
            if(sel && v.options[idx]!==sel.value){ ok=false; break; }
          }
          if(ok) return v;
        }
        return null;
      };
      var gSync=function(){
        var v=giftVariant();
        if(!v||!v.available){ gBtn.disabled=true; gBtn.textContent='Sold out'; }
        else { gBtn.disabled=false; gBtn.textContent=gBtn.getAttribute('data-label'); }
      };
      if(gOpts) gOpts.addEventListener('change', gSync);
      gSync();
      gBtn.addEventListener('click', function(){
        var v=giftVariant(); if(!v||!v.available||gBtn.disabled) return;
        var main=document.querySelector('form[action*="/cart/add"] input[name="id"]');
        var items=[{id:v.id,quantity:1}];
        if(main) items.unshift({id:parseInt(main.value,10),quantity:1});
        gBtn.disabled=true; gBtn.textContent='Adding…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){ return lllApplyBestCode(); })
          .then(function(){ window.location.href='/cart'; })
          .catch(function(){ gSync(); });
      });
      window.addEventListener('pageshow',function(e){ if(e.persisted) gSync(); });
    }
  }catch(e){ console.error('[lll-custom] gift card init failed:', e); }

  /* bundle teaser: smooth-scroll to the pairs section (native anchor as fallback) */
  var teaser=document.querySelector('[data-cx-teaser]');
  if(teaser){
    teaser.addEventListener('click',function(ev){
      var t=document.getElementById('lll-pairs-anchor');
      if(t){ ev.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); }
    });
  }
}
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', lllInit); } else { lllInit(); }

/* ===== v24: in-cart upsell card (drawer + /cart page) — the native replacement for
   Vitals' in-cart offers (built 2026-07-10, post-purchase-upsell/build/).
   Reads the live cart and offers ONE next step:
     A) exactly one minis set in cart -> add a 2nd set   (the minis30 automatic prices it)
     B) blanket in cart, no minis     -> add a 3-pack    (the bundle15 automatic prices it)
   No offer when minis >= 2 (volume deal already maxed) or when the cart is empty.
   The minis-only -> blanket direction is deliberately NOT offered here: whether bundle15
   stacks on a minis30 cart is a pending Rory combination decision, so the card never
   claims a % it can't guarantee. All prices are computed from live cart/product JSON —
   nothing hardcoded. % claims come from LLL_CU.pct (single source, must match the active
   automatics). SHIP GATE: this card must go live in the SAME sitting as the automatics
   (publish-checklist.md T0 order: discounts first, rollout after) or the claim copy lies.
   Kill switch: LLL_CU.enabled=false + re-push, or window.lllCartUpsellDisabled=true. */
var LLL_CU = {
  enabled: true,
  /* Rule toggles. bundleMinis (blanket in cart -> add a paid 3-pack) is OFF: the free-mini
     gift now owns the minis slot in blanket carts, so a paid 3-pack there double-ups AND its
     15% claim can't apply until Rory activates the automatics. Re-enable (ideally reframed to
     build on the free mini) once the automatics are live. (Thomas 2026-07-10) */
  rules: { secondSet: true, bundleMinis: true },
  /* product ids + percents duplicated from lllInit's LLL_IDS/LLL_PCT (those are
     function-scoped and unreachable here). Same live-verified source: Admin API
     pull 2026-07-10, post-purchase-upsell/build/discovery/products.json. */
  ids: { minis: [15568402612305, 15720622096465], blankets: [7845705416785, 15720615215185] },
  pct: { minis30: 0.30, b2nd: 0.60, bundle15: 0.15 },
    giftNote: { handle: 'lay-lay-mini',
      /* MUSLIN ONLY. The BXGY 'FREE Lay Lay Mini' is muslin-trigger only — the TEDDY
         blanket does NOT include a free mini, so this must never fire on a teddy cart
         and the copy must not imply 'every blanket'. (Thomas 2026-07-25) */
      triggerIds: [7845705416785],
      text: 'Your free mini, valued {value}, ships with your muslin blanket' },
  secondSet: {
    eyebrow: 'Two-set favourite',
    sub: '30% off both sets is applied in your cart',
    subB: '60% off your 2nd set is applied in your cart',   /* minis wording test, group B (Oct 2026) */
    btn: 'Add a 2nd set'
  },
  bundleMinis: {
    handle: 'mini-3-pack',
    eyebrow: 'Complete their comfort set',
    title: 'Lay Lay Minis · 3 Pack',
    sub: 'Your free mini plus three more, 15% off the pack',
      /* teddy carts include NO free mini, so the 'plus three more' framing would be a
         false claim there — swap to neutral copy. (Thomas 2026-07-25) */
      subNoGift: 'Three more textures to explore, 15% off the pack',
    btn: 'Add the minis'
  }
};
try{ if(LLL_CU.enabled && !window.lllCartUpsellDisabled){ (function(){
  var busy=false, queued=false, prodCache={};
  function fmt(cents,cur){
    try{ return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cur,currencyDisplay:'narrowSymbol'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2)+' '+cur; }
  }
  function thumb(u){ if(!u) return ''; return u+(u.indexOf('?')>-1?'&':'?')+'width=120'; }
  function anchors(){
    var a=[], d=document.getElementById('CartDrawer-CartItems'), m=document.getElementById('main-cart-items');
    if(d) a.push(d); if(m) a.push(m);
    return a;
  }
  function offerFor(cart){
    var minisQty=0, blanketQty=0, minisLine=null;
    cart.items.forEach(function(i){
      if(LLL_CU.ids.minis.indexOf(i.product_id)>-1){ minisQty+=i.quantity; if(!minisLine) minisLine=i; }
      if(LLL_CU.ids.blankets.indexOf(i.product_id)>-1){ blanketQty+=i.quantity; }
    });
    /* ONE ASK PER CART, and it stops once the set is complete (Thomas 2026-07-16).
       secondSet requires blanketQty===0. Without that it only tested minisQty===1, so accepting
       the blanket->minis upsell immediately triggered a SECOND pitch for another pack — the
       offer looked like it was overriding itself, and nobody designed that; it fell out of rule
       order. Orders 17 Apr–16 Jul (1,582 AUD): blanket+2packs = 9 (0.6%), blanket+1pack = 100
       @ $99.61 avg — the best cart shape in the store, 2x the $49.26 AOV. Not worth a third
       consecutive ask to chase ~3 orders/month. Minis-only 2-packs = 83, so the card keeps
       earning where the behaviour is real. */
    if(LLL_CU.rules.secondSet && minisQty===1 && blanketQty===0 && minisLine) return { rule:'secondSet', line:minisLine };
    if(LLL_CU.rules.bundleMinis && blanketQty>=1 && minisQty===0) return { rule:'bundleMinis' };
    return null;
  }
  function getProduct(handle){
    if(prodCache[handle]) return Promise.resolve(prodCache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){
      if(!r.ok) throw 0; return r.json();
    }).then(function(p){
      /* Design option (the Minis' "Label Design", 14 Oct 2026; Animals launch 1 Nov 2026). While the product's
         "Show design choice" box is off (window.LLL_SHOW_DESIGN, set in cart-drawer.liquid) only the first design is
         offered. The first design is never named in the dropdowns ("Blue / Woven Labels", not ".../ Signature");
         any other design keeps its name ("Woodland / Woven Labels / Animals"). */
      try{
        var di=-1; (p.options||[]).forEach(function(o,i){ if(di<0 && /design/i.test(o.name||'')) di=i; });
        if(di>-1){
          var dFirst=((p.options[di]||{}).values||[])[0];
          if(!(window.LLL_SHOW_DESIGN||{})[p.handle]) p.variants=(p.variants||[]).filter(function(v){ return !v.options || v.options[di]===dFirst; });
          (p.variants||[]).forEach(function(v){ if(v.options && v.options[di]===dFirst) v.title=v.options.filter(function(x,i){ return i!==di; }).join(' / '); });
        }
      }catch(e){}
      prodCache[handle]=p; return p;
    });
  }
  function addItems(items,btn){
    /* This card renders in BOTH the drawer and the /cart page. In the drawer,
       add in place and re-render so the drawer stays open (Thomas 2026-07-28);
       on /cart there is no drawer to paint, so keep the reload. */
    var inDrawer = !!(btn.closest('cart-drawer') || btn.closest('#CartDrawer'));
    if(inDrawer && document.querySelector('cart-drawer')){
      lllDrawerAdd(items,btn,function(){ window.location.href='/cart'; });
      return;
    }
    btn.disabled=true; btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw 0; window.location.href='/cart'; })
      .catch(function(){ btn.disabled=false; btn.textContent=btn.getAttribute('data-label'); });
  }
  function card(sig){
    var el=document.createElement('div');
    el.className='lll-cu'; el.setAttribute('data-lll-cu',sig); el.setAttribute('role','region'); el.setAttribute('aria-label','A little extra');
    /* Our card renders INSIDE Dawn's <cart-items>/<cart-drawer-items>, whose onChange treats
       ANY descendant change/input as a line-quantity edit -> in the drawer that surfaced
       "You can only add this item in increments of undefined" when the print <select> changed
       (Thomas 2026-07-19). Stop our controls' events at the card boundary so Dawn never sees
       them; our own price/atc handlers sit on the controls (deeper) and still fire first. */
    el.addEventListener('change', function(e){ e.stopPropagation(); });
    el.addEventListener('input', function(e){ e.stopPropagation(); });
    return el;
  }
  function renderSecondSet(host,offer,cart,sig){
    var c=LLL_CU.secondSet, line=offer.line, isB=(window.LLL_OFFER==='b');
    getProduct(line.handle).then(function(p){
      /* the observer may have re-rendered while we fetched — bail if a current card exists */
      if(host.querySelector('[data-lll-cu="'+sig+'"]')) return;
      var avail=(p.variants||[]).filter(function(v){ return v.available; });
      if(!avail.length) avail=[{id:line.variant_id, title:line.variant_title||'', price:line.original_price}];
      var el=card(sig);
      var opts=avail.map(function(v){
        var vi=(v.featured_image&&v.featured_image.src)||'';
        return '<option value="'+v.id+'" data-price="'+v.price+'" data-image="'+(vi?thumb(vi):'')+'"'+(v.id===line.variant_id?' selected':'')+'>'+String(v.title).replace(/</g,'&lt;')+'</option>';
      }).join('');
      el.innerHTML=
        '<img class="lll-cu__img" alt="" loading="lazy" src="'+thumb(line.image)+'">'+
        '<div class="lll-cu__txt">'+
          '<span class="lll-cu__eyebrow">'+c.eyebrow+'</span>'+
          '<b class="lll-cu__title">Add a second '+(line.product_title||'set').replace(/</g,'&lt;')+'</b>'+
          '<small class="lll-cu__sub">'+(isB?c.subB:c.sub)+'</small>'+
          (avail.length>1?'<select class="lll-cu__sel" aria-label="Choose your print">'+opts+'</select>':'')+
          '<span class="lll-cu__price"></span>'+
          '<button type="button" class="lll-cu__btn" data-label="'+c.btn+'">'+c.btn+'</button>'+
        '</div>';
      var priceEl=el.querySelector('.lll-cu__price'), sel=el.querySelector('.lll-cu__sel');
      function chosen(){
        if(!sel) return avail[0];
        for(var i=0;i<avail.length;i++){ if(String(avail[i].id)===sel.value) return avail[i]; }
        return avail[0];
      }
      function price(){
        /* group B: checkout takes the 60% off the CHEAPER pack, so with Animals (1 Nov 2026) show what the 2nd set
           really adds to the cart; with equal prices this is the same 40% of one pack as before */
        if(isB){ var one=chosen().price, lo=Math.min(one,line.original_price), d2=one-Math.round(lo*LLL_CU.pct.b2nd);
          priceEl.innerHTML='<b>'+fmt(d2,cart.currency)+'</b> for your 2nd set <s>'+fmt(one,cart.currency)+'</s>'; return; }
        var full=line.original_price+chosen().price;
        var deal=Math.round(full*(1-LLL_CU.pct.minis30));
        priceEl.innerHTML='<b>'+fmt(deal,cart.currency)+'</b> for both <s>'+fmt(full,cart.currency)+'</s>';
      }
      var imgEl=el.querySelector('.lll-cu__img');
      function swapImg(){ var o=sel&&sel.options[sel.selectedIndex]; if(imgEl&&o&&o.dataset.image) imgEl.src=o.dataset.image; }
      if(sel) sel.addEventListener('change',function(){ price(); swapImg(); });
      price(); swapImg();
      el.querySelector('.lll-cu__btn').addEventListener('click',function(){
        addItems([{id:chosen().id,quantity:1}],this);
      });
      host.appendChild(el);
    }).catch(function(){});
  }
  function renderBundleMinis(host,cart,sig){
    getProduct(LLL_CU.bundleMinis.handle).then(function(p){
      /* the observer may have re-rendered while we fetched — bail if a current card exists */
      if(host.querySelector('[data-lll-cu="'+sig+'"]')) return;
      var avail=(p.variants||[]).filter(function(v){ return v.available; });
      if(!avail.length) return;
      var c=LLL_CU.bundleMinis;
      var el=card(sig);
      var opts=avail.map(function(v,i){ var vi=(v.featured_image&&v.featured_image.src)||''; return '<option value="'+v.id+'" data-price="'+v.price+'" data-image="'+(vi?thumb(vi):'')+'"'+(i===0?' selected':'')+'>'+String(v.title).replace(/</g,'&lt;')+'</option>'; }).join('');
      el.innerHTML=
        '<img class="lll-cu__img" alt="" loading="lazy" src="'+thumb((p.featured_image||''))+'">'+
        '<div class="lll-cu__txt">'+
          '<span class="lll-cu__eyebrow">'+c.eyebrow+'</span>'+
          '<b class="lll-cu__title">'+c.title+'</b>'+
          '<small class="lll-cu__sub">'+(blanketQtyIn(cart)>0?c.sub:(c.subNoGift||c.sub))+'</small>'+
          (avail.length>1?'<select class="lll-cu__sel" aria-label="Choose your print">'+opts+'</select>':'')+
          '<span class="lll-cu__price"></span>'+
          '<button type="button" class="lll-cu__btn" data-label="'+c.btn+'">'+c.btn+'</button>'+
        '</div>';
      var priceEl=el.querySelector('.lll-cu__price'), sel=el.querySelector('.lll-cu__sel');
      function price(){
        var v=sel?avail.find(function(x){ return String(x.id)===sel.value; }):avail[0];
        var deal=Math.round(v.price*(1-LLL_CU.pct.bundle15));
        priceEl.innerHTML='<b>'+fmt(deal,cart.currency)+'</b> with your blanket <s>'+fmt(v.price,cart.currency)+'</s>';
      }
      var imgEl=el.querySelector('.lll-cu__img');
      function swapImg(){ var o=sel&&sel.options[sel.selectedIndex]; if(imgEl&&o&&o.dataset.image) imgEl.src=o.dataset.image; }
      if(sel) sel.addEventListener('change',function(){ price(); swapImg(); });
      price(); swapImg();
      el.querySelector('.lll-cu__btn').addEventListener('click',function(){
        var id=sel?parseInt(sel.value,10):avail[0].id;
        addItems([{id:id,quantity:1}],this);
      });
      host.appendChild(el);
    }).catch(function(){});
  }
  /* .finally() isn't guaranteed in older in-app browsers — release via .then(fn,fn) */
  function blanketQtyIn(cart){
    var n=0, trig=(LLL_CU.giftNote&&LLL_CU.giftNote.triggerIds)||LLL_CU.ids.blankets;
    cart.items.forEach(function(i){ if(trig.indexOf(i.product_id)>-1) n+=i.quantity; });
    return n;
  }
  function renderGiftNote(host,cart,gsig){
    var c=LLL_CU.giftNote;
    getProduct(c.handle).then(function(p){
      if(host.querySelector('[data-lll-mininote="'+gsig+'"]')) return;
      var v=(p.variants||[])[0];
      if(!v) return;
      var el=document.createElement('p');
      el.className='lll-mininote'; el.setAttribute('data-lll-mininote',gsig);
      el.textContent=c.text.replace('{value}', fmt(v.price,cart.currency));
      var below=host.querySelector('[data-lll-cu]');
      if(below) host.insertBefore(el,below); else host.appendChild(el);
    }).catch(function(){});
  }
  function refresh(){
    if(busy){ queued=true; return; }
    var release=function(){ busy=false; if(queued){ queued=false; setTimeout(refresh,50); } };
    if(!anchors().length) return;
    busy=true;
    fetch('/cart.js',{cache:'no-store'}).then(function(r){ return r.json(); }).then(function(cart){
      var offer=cart.item_count?offerFor(cart):null;
      var sig=offer?(offer.rule+':'+(offer.line?offer.line.variant_id:'')+':'+cart.currency):'';
          /* the gift note tracks the blanket, not the offer, so it needs its own signature */
          var gsig=''; /* LLL 2026-10-04 (Thomas): free-mini note retired. The $0 free mini line shows in the cart; the note flashed up before that line landed. An empty signature also removes any note already on the page. */
      anchors().forEach(function(host){
            var curG=host.querySelector('[data-lll-mininote]');
            if(!curG || curG.getAttribute('data-lll-mininote')!==gsig){ if(curG) curG.remove(); if(gsig) renderGiftNote(host,cart,gsig); }
        var cur=host.querySelector('[data-lll-cu]');
        if(cur && cur.getAttribute('data-lll-cu')===sig) return;
        if(cur) cur.remove();
        if(!offer) return;
        if(offer.rule==='secondSet') renderSecondSet(host,offer,cart,sig);
        else renderBundleMinis(host,cart,sig);
      });
    }).catch(function(){}).then(release,release);
  };
  var t=null;
  function poke(){ clearTimeout(t); t=setTimeout(refresh,200); }
  function arm(){
    var d=document.getElementById('CartDrawer');
    if(d) new MutationObserver(poke).observe(d,{childList:true,subtree:true});
    var m=document.getElementById('main-cart-items');
    if(m && m.parentNode) new MutationObserver(poke).observe(m.parentNode,{childList:true,subtree:true});
    window.addEventListener('pageshow',function(e){ if(e.persisted) poke(); });
    refresh();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',arm); } else { arm(); }
})(); } }catch(e){ console.error('[lll-custom] cart upsell init failed:', e); }

})();

/* ===== external links open in a new tab (Draft A, Rory 2026-07-19, Vitals parity) =====
   Keeps shoppers on Lay Lay Labels: any link to a DIFFERENT site opens in a new tab with
   rel="noopener noreferrer" (security + privacy). Internal links, Shopify infra/checkout,
   in-page anchors, mailto/tel, and links that already set target are left untouched. */
try{ (function(){
  function isExternal(a){
    var href=a.getAttribute('href')||'';
    if(!/^https?:\/\//i.test(href)) return false;           // relative, #, mailto:, tel:, javascript:
    if(a.target) return false;                               // author already chose a target
    var h;
    try{ h=new URL(a.href).hostname; }catch(e){ return false; }
    if(h===location.hostname) return false;                  // same site
    if(/(^|\.)shopify\.com$|(^|\.)myshopify\.com$|(^|\.)shopifycdn\.com$/i.test(h)) return false; // Shopify infra/checkout
    return true;
  }
  function mark(root){
    (root||document).querySelectorAll('a[href^="http"]').forEach(function(a){
      if(isExternal(a)){ a.target='_blank'; a.rel=(a.rel?a.rel+' ':'')+'noopener noreferrer'; }
    });
  }
  mark(document);
  /* re-mark links added later (cart drawer, ajax content); debounced, cheap */
  var t=null;
  new MutationObserver(function(){ clearTimeout(t); t=setTimeout(function(){ mark(document); },300); })
    .observe(document.body,{childList:true,subtree:true});
})(); }catch(e){ console.error('[lll-custom] external-links init failed:', e); }
